import productApi from '~/apis/fetchAllProducts'

export default defineNuxtPlugin({
	name: 'product-requests',
	async setup(e) {
		const { getProducts, getProductCategories } = useProductApi()
		const productsStore = useProductsStore()
		const { FetchCoverPeriod } = productApi()

		// Helper to fetch and store products for a platform
		const fetchProducts = async (platform: 'business' | 'individual' | 'diaspora') => {
			try {
				const [products, productCategories] = await Promise.allSettled([
					getProducts(platform),
					getProductCategories(null, platform),
					FetchCoverPeriod(platform)
				])

				if (products.status === 'fulfilled' && products.value) {
					if (platform === 'individual') {
						productsStore.groupIndividualProduct(products.value?.groupedByName ?? {})
						productsStore.storeIndividualProductList(products.value?.productList ?? [])
					} else if (platform === 'diaspora') {
						productsStore.groupDiasporaProduct(products.value?.groupedByName ?? {})
						productsStore.storeDiasporaProductList(products.value?.productList ?? [])

						// Set initial filter key for SendCare pricing
						const keys = Object.keys(products.value?.groupedByName ?? {})
						if (keys.length) {
							productsStore.productFilterKey = keys[0]
						}
					} else {
						productsStore.storeGroupedProducts(products.value?.groupedByName ?? {})
						productsStore.storeProductList(products.value?.productList ?? [])
					}
				}

				if (productCategories.status === 'fulfilled' && productCategories.value) {
					productsStore.storeProductCategories(productCategories.value?.productCategories ?? [])
					productsStore.storeGroupedProduct(productCategories.value?.groupedProducts ?? {})
				}
			} catch (err) {
				console.error(`Failed to fetch ${platform} products in plugin:`, err)
			}
		}

		// Initial fetch based on the current route
		const route = useRoute()
		const getPlatform = (path: string) => {
			if (path.includes('sendcare')) return 'diaspora'
			if (path.includes('individual')) return 'individual'
			return 'business'
		}

		// Initial SSR fetch
		await useAsyncData('initial-products', async () => {
			await fetchProducts(getPlatform(route.path))
			return true
		})

		// Client-side navigation watch
		if (import.meta.client) {
			watch(
				() => route.path,
				async (newPath) => {
					const newPlatform = getPlatform(newPath)
					await fetchProducts(newPlatform)
				}
			)
		}
	}
})
